import {Hub} from 'aws-amplify/utils';
import React, {useEffect, useState} from 'react';
import Login from './login';
import ConfirmSignIn from './confirm-sign-in';
import ForgetPassword from './forget-password';
import CreatePassword from './create-password';
import {AuthView} from '../services/authorization-service';

export const UnauthenticatedAuthRouter = () => {

    const [view, setView] = useState<AuthView>(AuthView.SignIn)

    useEffect(() => {
        const uiUnsub = Hub.listen('UI Auth', ({ payload }) => {
            const { message } = payload || {};
            if (typeof message === 'string') setView(message as AuthView);
        });

        const authUnsub = Hub.listen('auth', ({ payload }) => {
            const { event } = payload || {};
            if (event === 'signedOut') setView(AuthView.SignIn);
        });

        return () => {
            if (typeof uiUnsub === 'function') uiUnsub();
            if (typeof authUnsub === 'function') authUnsub();
        };
    }, []);

    switch (view) {
        case AuthView.SignIn:
            return <Login />
        case AuthView.ConfirmSignIn :
            return <ConfirmSignIn />
        case AuthView.ForgotPassword:
            return <ForgetPassword />
        case AuthView.ResettingPassword:
            return <CreatePassword />
        default:
            return <Login />
    }

}